import React, { Component, useEffect, useState } from 'react';
import { Link } from 'gatsby';
import Navbar from 'react-bootstrap/Navbar';
import { NavbarBrand } from 'react-bootstrap';
import Cta from 'components/common/Cta';
import { trackMenuOpened, trackMenuLinkClicked } from 'utils/segment';
import useNavbarEffect from 'components/common/CharlesLayout/useNavbarEffect';
import Logo from 'images/new-images/logo-charles.svg';
import BurgerMenu from 'images/new-images/burger-menu.svg';
import CloseMenu from 'images/new-images/menu-close.svg';
import Arrow from 'images/menu-icons/menu-icon.svg';
import LoginIcon from 'images/new-images/login-icon.svg';
import { data } from './menu-data';
import Image from 'components/common/utils/Image';
import { frontAppUrl } from 'utils/siteConfig';
import ContactTopBanner from '../ContactTopBanner';
import { pathologiesToShow } from "templates/Pathologies/utils/tools";
import './styles.sass'

const DefaultHeader = () => {
  const [toggleMenu, setToggleMenu] = useState(false);
  const [scrollBarWidth, setScrollBarWidth] = useState(0);
  const [navbarFixed, setNavbarFixed] = useNavbarEffect();

  const [isMobile, setIsMobile] = useState(false);
  const [activeMenuItem, setActiveMenuItem] = useState(data[0].id);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    setIsMobile(window.matchMedia('(max-width: 1100px)').matches)
    const onResize = () => setIsMobile(window.matchMedia('(max-width: 1100px)').matches);
    window.addEventListener('resize', onResize, { passive: true });
    return () => window.removeEventListener('resize', onResize);
  }, []);

  useEffect(() => {
    setScrollBarWidth(
      window.offsetWidth - document.documentElement.clientWidth,
    );
  }, []);

  function disableScroll() {
    document.body.classList.add('stop-scrolling');
    document.body.style.paddingRight = `${scrollBarWidth}px`;
    // put below every absolute positioned elements and set the paddingRight
    document.getElementById(
      'contact-top-banner',
    ).style.paddingRight = `${scrollBarWidth}px`;
    document.getElementById(
      'navbar-menu',
    ).style.paddingRight = `${scrollBarWidth}px`;
    if (!isMobile) {
      document.getElementById(
        'desktop-deployed-menu',
      ).style.right = `${scrollBarWidth}px`;
    }
  }
  function activateScroll() {
    document.body.classList.remove('stop-scrolling');
    document.body.style.paddingRight = '0';
    // put below every absolute positioned elements and set the paddingRight
    document.getElementById('contact-top-banner').style.paddingRight = '0';
    document.getElementById('navbar-menu').style.paddingRight = '0';
    if (!isMobile) {
      document.getElementById('desktop-deployed-menu').style.right = '0';
    }
  }

  function toggleScroll() {
    if (toggleMenu === true) {
      setToggleMenu(false);
      activateScroll();
    } else {
      setToggleMenu(true);
      disableScroll();
    }
  }

  function displayDesktopMenu() {
    const menu = document.getElementById('desktop-deployed-menu');
    const backgroundMenu = document.getElementById('desktop-background-menu');
    const triangle = document.getElementById('header-triangle-menu');
    const pathologyTemplate = document.getElementById('pathology-template');
    const tag = document.getElementById('menu-cta-image');
    menu.classList.toggle('toggle-charles-desktop-menu');
    backgroundMenu.classList.add('charles-desktop-background-menu');
    if (menu.classList.contains('toggle-charles-desktop-menu')) {
      backgroundMenu.classList.add('charles-desktop-background-menu');
      triangle.style.display = 'initial';
      setNavbarFixed(true);
      tag.style.transform = 'rotate(-90deg)';
      menu.style.position = 'fixed';
      menu.style.top = `${document.getElementById('navbar-menu').offsetHeight}px`;
    } else {
      backgroundMenu.classList.remove('charles-desktop-background-menu');
      triangle.style.display = 'none';
      setNavbarFixed(false);
      tag.style.transform = 'rotate(90deg)';
    }
  }

  function clickOutside() {
    displayDesktopMenu();
    toggleScroll();
  }

  function closeAllMenu(e) {
    closeSubMenu()
    handleBurgerClick(e)
  }

  function handleBurgerClick(e) {
    trackMenuOpened();
    const tag = document.getElementById('menu-cta-image');
    if (window.matchMedia('(min-width: 1100px)').matches) {
      toggleScroll();
      displayDesktopMenu();
    } else {
      toggleScroll();
      const menu = document.getElementById('deployed-menu');
      const triangle = document.getElementById('header-triangle-menu');
      if (
        e.currentTarget.id === 'header-close-menu'
        || e.currentTarget.id === 'header-burger-menu'
        || e.currentTarget.id === 'header-close-sub-menu'
      ) {
        const burger = document.getElementById('header-burger-menu');
        const close = document.getElementById('header-close-menu');
        if (burger.style.display !== 'none') {
          burger.style.display = 'none';
          close.style.display = 'initial';
          triangle.style.display = 'none';
          menu.style.top = `${window.pageYOffset}px`;
          menu.classList.toggle('toggle-charles-menu');
        } else {
          menu.classList.toggle('toggle-charles-menu');
          burger.style.display = 'initial';
          close.style.display = 'none';
          triangle.style.display = 'none';
        }
      } else {
        menu.style.top = `${window.pageYOffset}px`;
        menu.classList.toggle('toggle-charles-menu');
        if (menu.classList.contains('toggle-charles-menu')) {
          tag.style.transform = 'rotate(-90deg)';
          triangle.style.display = 'initial';
        } else {
          tag.style.transform = 'rotate(90deg)';
          triangle.style.display = 'none';
        }
      }
    }
  }

  function shouldShowAllPathologies(categoryId) {
    return !["therapy-category", "poids-category"].includes(categoryId)
  }

  function linkRel(categoryId) {
    categoryId == "poids-category" ? "nofollow noopener noreferrer" : ""
  }

  function menuSpecialtiesList(categoryId) {
    const selectedCategory = data.find((category) => category.id == categoryId)
    return {
      'title': selectedCategory,
      'innerWording': selectedCategory.innerWording,
      'items': selectedCategory.items
    }
  }

  function openSubMenu(id) {
    setShowModal(true)
    setActiveMenuItem(id)
    const menu = document.getElementById('deployed-menu')
    menu.classList.add('hidden-top-bar')

  }

  function closeSubMenu() {
    setShowModal(false)
    const menu = document.getElementById('deployed-menu')
    menu.classList.remove('hidden-top-bar')
  }

  function trackMenuItemClick(to, name) {
    if(to && name) {
      trackMenuLinkClicked(to, name)
    }
  }

  return (
    <>
      <header className="default-header">
        <div id="navbar-menu" className="fixed-top">
          <ContactTopBanner />
          <Navbar className="default-header-navbar">
            <NavbarBrand className="default-header-logo">
              <Link to="/">
                <Logo
                  aria-label="logo charles clinique digitale"
                  title="charles clinique digitale logo"
                  alt="charles-clinique-digitale-logo"
                  width={104}
                  className=""
                />
              </Link>
            </NavbarBrand>
            <div className="default-header-menu">
              {!isMobile && <div className="default-header-menu-links">
                <Link activeStyle={{ textDecoration: 'underline' }} to="/comment-ca-marche/">Comment ça marche ?</Link>
                <Link activeStyle={{ textDecoration: 'underline' }} to="/approche-medicale/">Notre approche médicale</Link>
                {/* <Link activeStyle={{ textDecoration: 'underline' }} to="/faq/">FAQ</Link> */}
                <Link activeStyle={{ textDecoration: 'underline' }} to="/blog/">Blog</Link>
              </div>}
              <BurgerMenu
                alt="Burger menu icon"
                id="header-burger-menu"
                onClick={handleBurgerClick}
              />
              <CloseMenu
                alt="Close menu icon"
                id="header-close-menu"
                onClick={handleBurgerClick}
              />
              <div
                id="header-cta-menu"
                className="header-md-menu"
                onClick={handleBurgerClick}
              >
                <div>Menu</div>
                <div>Nos spécialités</div>
                <Image
                  id="menu-cta-image"
                  filename="new-images/right-tag.svg"
                  alt="fleche-droite-picto"
                  title="fleche droite picto"
                />
              </div>
              <Image
                filename="new-images/menu-triangle.svg"
                id="header-triangle-menu"
                alt="fleche-pleine-haut-picto"
                title="fleche pleine haut picto"
              />
              <div className="navbar-menu-separator" />
              <Cta
                className="new-primary-cta navbar-menu-cta"
                text="Consulter"
                path="/consulter/"
              />
              <a
                href={`${frontAppUrl}/me.html`}
                rel="noopener noreferrer nofollow"
                className="navbar-menu-connection"
              >
                <div className="navbar-menu-connection-label">Connexion</div>
                <LoginIcon
                  alt="login icon"
                  className="navbar-menu-connection-icon"
                />
              </a>
            </div>
          </Navbar>
        </div>
        <div id="desktop-background-menu" onClick={clickOutside} />
        {!isMobile ? (
          <div
            id="desktop-deployed-menu"
            className="charles-desktop-deployed-menu d-none d-xl-flex"
          >
            <div className="desktop-deployed-menu-specialties">
              <div className="desktop-deployed-menu-specialties-div menu-specialties-separation">
                {data.map((spe, i) => (
                    <Link key={i} to="">
                      <div
                        onMouseEnter={() => setActiveMenuItem(spe.id)}
                        onClick={() => setActiveMenuItem(spe.id)}
                        className={spe.classes.concat(" ", (activeMenuItem == spe.id ? "inline-menu-category-selected" : ''))}
                      >
                        <div className="menu-category-icon">
                          <Image
                            id={spe.id}
                            filename={spe.icon}
                            alt={spe.alt}
                            title={spe.title}
                          />
                        </div>
                        <div className="h4">{spe.name}</div>
                        <div className="menu-category-arrow">
                          <Arrow
                            alt="Arrow menu icon"
                            id="header-arrow-menu"
                          />
                        </div>
                      </div>
                    </Link>
                ))}
              </div>
              <div className="desktop-deployed-menu-specialties-div">
                {
                  data.map((category) => (
                    <div className={`desktop-deployed-menu-specialties-link-wrapper${category.id !== activeMenuItem ? " hide-specialties" : ""}`}>
                      {menuSpecialtiesList(category.id)['items'].map((spe, i) => (
                        <Link
                          to={spe.to}
                          rel={linkRel(category.id)}
                          key={`${category.categorySlug}_${i}`}
                          onClick={() => trackMenuItemClick(menuSpecialtiesList(category.id)['title'].to, spe.name)}
                        >
                          {spe.name}
                        </Link>
                      ))}
                      {
                         shouldShowAllPathologies(category.id) && <Link
                            to={menuSpecialtiesList(category.id)['title'].to}
                            onClick={() => trackMenuItemClick(menuSpecialtiesList(category.id)['title'].to, menuSpecialtiesList(category.id)['title'].name)}
                          >
                            Toutes nos pathologies {category.innerWording}
                          </Link>
                      }
                    </div>
                  ))
                }
              </div>
            </div>
            <div className="desktop-deployed-menu-other-links">
              <div className="h5">Prenez soin de vous :</div>
              <Cta
                text="Consultez un médecin"
                className="new-primary-cta desktop-deployed-menu-other-links-cta"
                path="/consulter/"
              />
              <div className="desktop-deployed-menu-question">
                Vous avez des questions :
              </div>
              <Link to="/faq/" className="desktop-deployed-menu-link">
                <Image
                  filename="new-images/blue-book.svg"
                  alt="livre-bleu-pictoo"
                  title="livre bleu picto"
                />
                <div>FAQ complète</div>
              </Link>
              <a href="tel:+33186651733" className="desktop-deployed-menu-link">
                <Image
                  filename="new-images/blue-phone.svg"
                  alt="mobile-bleu-picto"
                  title="mobile bleu picto"
                />
                <div>01 86 65 17 33</div>
              </a>
              <a
                href="mailto:contact@charles.co"
                className="desktop-deployed-menu-link"
              >
                <Image
                  filename="new-images/blue-mail.svg"
                  alt="mail-bleu-picto"
                  title="mail bleu picto"
                />
                <div>contact@charles.co</div>
              </a>
            </div>
          </div>
        ) : (
          <div>
            <div id="deployed-menu" className="charles-deployed-menu d-xl-none">
              <div className={`sub-menu-items ${!showModal ? " hide-specialties" : ""}`}>
                <div className="sub-menu-top-bar">
                  <div className="sub-menu-rollback" onClick={() => closeSubMenu()}>
                    <Image
                      id="sub-menu-arrow"
                      filename="new-images/tag.svg"
                      alt="chevron-flèches"
                      title="chevron flèches"
                    />
                  <span>Menu</span>
                  </div>
                  <div className="sub-menu-hide-button">
                    <CloseMenu
                      alt="Close sub menu"
                      id="header-close-sub-menu"
                      onClick={closeAllMenu}
                    />
                  </div>
                </div>
                <div className="sub-menu-items-links">
                  {
                    data.map((category) => (
                      <div className={`${category.id !== activeMenuItem ? " hide-specialties" : ""}`}>
                        <div className="submenu-category-title">{menuSpecialtiesList(category.id)['title'].name}</div>
                        {menuSpecialtiesList(category.id)['items'].map((spe, i) => (
                          <div className="phathology-direct-link-section">
                            <Link
                              to={spe.to}
                              rel={linkRel(category.id)}
                              onClick={() => trackMenuItemClick(menuSpecialtiesList(category.id)['title'].to, spe.name)}
                            >
                              {spe.name}
                            </Link>
                          </div>
                        ))}
                        {
                          shouldShowAllPathologies(category.id) && <div className="phathology-direct-link-section">
                            <Link
                              to={menuSpecialtiesList(category.id)['title'].to}
                              onClick={() => trackMenuItemClick(menuSpecialtiesList(category.id)['title'].to, menuSpecialtiesList(category.id)['title'].name)}
                            >
                              Toutes nos pathologies {category.innerWording}
                            </Link>
                          </div>
                        }
                      </div>
                    ))
                  }
                </div>
              </div>
              <div className={`${showModal ? " hide-specialties" : ""}`}>
                <div className="deployed-menu-specialties-list mt-4">
                  {data.map((spe, i) => (
                    <div className="deployed-menu-specialty-section" key={i}>
                      <div className="deployed-menu-specialty-name" onClick={() => openSubMenu(spe.id)}>
                        <div className="h4">{spe.name}</div>
                        <Image
                          id={`menuTag${i}`}
                          filename="new-images/tag.svg"
                          alt="chevron-flèches"
                          title="chevron flèches"
                          className="deployed-menu-tag"
                        />
                      </div>
                    </div>
                  ))}
                </div>
                <div className="deployed-menu-other-links-div">
                  <Link to="/comment-ca-marche/">Comment ça marche ?</Link>
                  <Link to="/approche-medicale/">
                    Notre approche médicale
                  </Link>
                  <Link to="/blog/">Blog</Link>
                </div>
                <div className="deployed-menu-other-links-div">
                  <div className="take-care-section">Prenez soin de vous :</div>
                  <Cta
                    text="Consultez un médecin"
                    className="new-primary-cta"
                    path="/consulter/"
                  />
                </div>
                <div className="deployed-menu-question-div">
                  <div className="h3">Vous avez des questions :</div>
                  <div className="deployed-menu-question-div-link-wrapper">
                    <Link to="/faq/">
                      <Image
                        filename="new-images/menu-book.svg"
                        alt="livre-bleu-picto-2"
                        title="livre bleu picto-2"
                      />
                      <div>FAQ complète</div>
                    </Link>
                    <a href="tel:+33186651733">
                      <Image
                        filename="new-images/menu-phone.svg"
                        alt="mobile-bleu-picto-2"
                        title="mobile bleu picto-2"
                      />
                      <div>01 86 65 17 33</div>
                    </a>
                    <a href="mailto:contact@charles.co">
                      <Image
                        filename="new-images/menu-envelope.svg"
                        alt="enveloppe-bleu-picto"
                        title="enveloppe bleu picto"
                      />
                      <div>contact@charles.co</div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </header>
    </>
  );
};

export default DefaultHeader;
